import { CAR_TYPE } from "constants/constants";
import { translate } from "utils";
import { FORM_REQUEST_STATUS, FORM_REQUEST_TYPE, FormRequest } from "./type";

export const FORM_REQUEST_COLOR = {
	NEW: "#4096ff",
	PROCESSING: "#ffa940",
	SOLVED: "#73d13d",
};
export const FormRequestStatusElements = {
	[FORM_REQUEST_STATUS.NEW]: {
		label: "Wait list",
		value: FORM_REQUEST_STATUS.NEW,
		color: FORM_REQUEST_COLOR.NEW,
	},
	[FORM_REQUEST_STATUS.PROCESSING]: {
		label: "Processing",
		value: FORM_REQUEST_STATUS.PROCESSING,
		color: FORM_REQUEST_COLOR.PROCESSING,
	},
	[FORM_REQUEST_STATUS.SOLVED]: {
		label: "Solved",
		value: FORM_REQUEST_STATUS.SOLVED,
		color: FORM_REQUEST_COLOR.SOLVED,
	},
};
export const FormRequestTypeElements = {
	[FORM_REQUEST_TYPE.SERVICE_REQUEST]: {
		label: "Service request",
		value: FORM_REQUEST_TYPE.SERVICE_REQUEST,
	},
	[FORM_REQUEST_TYPE.CAR_REQUEST]: {
		label: "Car request",
		value: FORM_REQUEST_TYPE.CAR_REQUEST,
	},
	[FORM_REQUEST_TYPE.CONTACT]: {
		label: "Contact",
		value: FORM_REQUEST_TYPE.CONTACT,
	},
	[FORM_REQUEST_TYPE.INVESTMENT]: {
		label: "Investment",
		value: FORM_REQUEST_TYPE.INVESTMENT,
	},
	[FORM_REQUEST_TYPE.CANDIDATE]: {
		label: "Candidate",
		value: FORM_REQUEST_TYPE.CANDIDATE,
	},
	[FORM_REQUEST_TYPE.PRODUCT_REQUEST]: {
		label: "Accessories",
		value: FORM_REQUEST_TYPE.PRODUCT_REQUEST,
	},
	[FORM_REQUEST_TYPE.CAR_CARE_SERVICE]: {
		label: "Car care",
		value: FORM_REQUEST_TYPE.CAR_CARE_SERVICE,
	},
	[FORM_REQUEST_TYPE.SELL_YOUR_CAR]: {
		label: "Sell your car",
		value: FORM_REQUEST_TYPE.SELL_YOUR_CAR,
	},
	[FORM_REQUEST_TYPE.IMPORT_CAR]: {
		label: "Import supercar",
		value: FORM_REQUEST_TYPE.IMPORT_CAR,
	},
};
export const FormRequestTypeOptions = [
	FormRequestTypeElements[FORM_REQUEST_TYPE.SERVICE_REQUEST],
	FormRequestTypeElements[FORM_REQUEST_TYPE.CAR_REQUEST],
	FormRequestTypeElements[FORM_REQUEST_TYPE.CONTACT],
	FormRequestTypeElements[FORM_REQUEST_TYPE.PRODUCT_REQUEST],
	FormRequestTypeElements[FORM_REQUEST_TYPE.CAR_CARE_SERVICE],
	FormRequestTypeElements[FORM_REQUEST_TYPE.SELL_YOUR_CAR],
	FormRequestTypeElements[FORM_REQUEST_TYPE.IMPORT_CAR],
];
export const getTypeLabel = (record?: FormRequest) => {
	// if (record?.type === FORM_REQUEST_TYPE.SELL_YOUR_CAR) {
	// 	return translate("Sell your car");
	// }

	if (record?.source) {
		switch (record?.type) {
			case FORM_REQUEST_TYPE.SERVICE_REQUEST:
				return record?.source?.name;
			case FORM_REQUEST_TYPE.CAR_REQUEST:
				return translate(CAR_TYPE[record?.source?.type || ""]?.label);
		}
	}
	return null;
};
